import common from './pages/common';
import websites from './pages/websites';
import statistics from './pages/statistics';
import operatores from './pages/operators';
import installation from './pages/installation';
import blackList from './pages/blackList';
import packagesCompare from './pages/packagesCompare';
import packageUpgrading from './pages/packageUpgrading';
import conversationCharge from './pages/conversationCharge';
import billsList from './pages/billsList';
import whatsapp from './pages/whatsapp';
import settings from './pages/settings';
import convArchive from './pages/convArchive';
import faq from './pages/FAQ';
import webhook from './pages/webhook';
import groupMsg from './pages/groupMsg';
import team from './pages/Team';
import auth from './pages/auth';
import affiliate from './pages/affiliate';
import notifs from './messages';
import appsList from './pages/appsList';
import KnowledgeBase from './pages/knowledgeBase';

const sections = {
  COMMON: common,
  WEBSITES: websites,
  STATISTICS: statistics,
  OPERATORS: operatores,
  INSTALLATION: installation,
  BLACKLIST: blackList,
  PACKAGE_UPGRADING: packageUpgrading,
  CONVERSATION_CHARGE: conversationCharge,
  BILLS_LIST: billsList,
  WHATSAPP: whatsapp,
  SETTINGS: settings,
  ARCHIVE: convArchive,
  FAQ: faq,
  WEBHOOK: webhook,
  GROUPMSG: groupMsg,
  TEAM: team,
  AUTH: auth,
  AFFILIATE: affiliate,
  NOTIFS_MESSAGES: notifs,
  APPSLIST: appsList,
  KNOWLEDGE_BASE: KnowledgeBase,
  PACKAGES_COMPARE: packagesCompare,
};

export default sections;
